import React from "react";
import { Dropdown, Menu, Popconfirm, Tooltip } from "antd";
import { MoreOutlined, FileSearchOutlined, EditOutlined,DeleteOutlined, } from "@ant-design/icons";

export default function ActionsDropdown({ onView, onEdit, onDelete, extraItems = [] }) {
  const items = []

  if (onView) {
    items.push(
      <Menu.Item key="view" onClick={onView}>
        <Tooltip title="Ver Detalle" mouseEnterDelay={0.2}>
          <span>
            <FileSearchOutlined style={{ color: "#1890ff", marginRight: 8 }} />
            Ver Detalle
          </span>
        </Tooltip>
      </Menu.Item>
    )
  }

  if (onEdit) {
    items.push(
      <Menu.Item key="edit" onClick={onEdit}>
        <Tooltip title="Editar" mouseEnterDelay={0.2}>
          <span>
            <EditOutlined style={{ color: "#1890ff", marginRight: 8 }} />
            Editar
          </span>
        </Tooltip>
      </Menu.Item>
    )
  }

  if (onDelete) {
    items.push(
      <Menu.Item key="delete">
        <Popconfirm
          title="¿Deseas eliminar esta Transacción?"
          okText="Sí"
          cancelText="No"
          placement="left"
          onConfirm={onDelete}
        >
          <Tooltip title="Eliminar" mouseEnterDelay={0.2}>
            <span
              onClick={(e) => {
                e.domEvent?.stopPropagation?.()
                e.stopPropagation?.()
                e.preventDefault?.()
              }}
            >
              <DeleteOutlined style={{ color: "#ff4d4f", marginRight: 8 }} />
              Eliminar
            </span>
          </Tooltip>
        </Popconfirm>
      </Menu.Item>
    )
  }

  extraItems.forEach(({ key, label, icon, onClick, confirm }) => {
    if (!confirm) {
      items.push(
        <Menu.Item 
          key={key} 
          onClick={onClick}>
          {icon} 
          {label}
        </Menu.Item>
      )
    } 
  })

  if (items.length === 0) {

    const emptyMenu = (
      <Menu>
        <Menu.Item disabled>No hay acciones</Menu.Item>
      </Menu>
    )

    return (
      <Dropdown overlay={emptyMenu} trigger={["click"]} placement="bottomRight">
        <MoreOutlined style={{ fontSize: 24, cursor: "pointer", lineHeight: 1 }} />
      </Dropdown>
    )

  }

  const menu = <Menu>{items}</Menu>

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <MoreOutlined
        style={{ fontSize: 22, cursor: "pointer", lineHeight: 1 }}
      />
    </Dropdown>
  )  
}
